import { FC, HTMLAttributes } from "react";
import { useStyles } from "./StatCard.style";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { StaticImage } from "../StaticImage";

interface IStatCardProps {
  statName: string;
  statContent: string | React.ReactNode;
  icons: {
    src: string;
    src2x: string;
    src3x: string;
  };
}

export const StatCard: FC<IStatCardProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { statName, statContent, icons } = props;

  return (
    <div className={classes.root}>
      <div className={classes.statContent}>
        <Typography
          variant={TypographyVariant.BodyB6Medium}
          className={classes.statName}
          data-testid={statName.toLowerCase().replace(/ /g, "-")}
        >
          {statName}
        </Typography>
        {typeof statContent !== "object" ? (
          <Typography variant={TypographyVariant.HeadingH4Bold}>
            {statContent}
          </Typography>
        ) : (
          statContent
        )}
      </div>
      <StaticImage
        src={icons.src}
        src2x={icons.src2x}
        src3x={icons.src3x}
        className={classes.statIcon}
      />
    </div>
  );
};
